export default () => ({
  playing: false,
  video: null,
  muted: true,
  init() {
    this.video = this.$root.querySelector("video");
    if (!this.video) return;

    // Set up video event listeners
    this.video.addEventListener("play", () => {
      this.playing = true;
    });

    this.video.addEventListener("pause", () => {
      this.playing = false;
    });
  },
  toggle() {
    this.playing = !this.playing;

    if (this.playing) {
      this.video.play();
    } else {
      this.video.pause();
    }
  },
  toggleMute() {
    this.muted = !this.muted;
    
    if (this.muted) {
      this.video.muted = true;
    } else {
      this.video.muted = false;
    }
  }
});
